import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = ({
  avatar ,
  userCode = "USER",
  onLogout = () => {},
  menuItems = [],
  isRetailerMobile = false
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="relative">
      {/* Trigger Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={`group flex items-center rounded-xl py-1.5 gap-1
          ${
            isRetailerMobile
              ? "px-3 bg-white/10 backdrop-blur-2xl border border-white/30 text-slate-900 shadow-[0_10px_30px_rgba(31,38,135,0.25)]"
              : "bg-blue-800 text-white"
          }`}
      >
        <img
          src={avatar}
          alt="Avatar"
          className="h-6 w-6 rounded-full object-cover"
        />
        {!isRetailerMobile && (
          <span className="text-xs">{userCode}</span>
        )}
        <ChevronDown size={16} className="opacity-80" />
      </button>

      {/* Dropdown Menu */}
      {open && (
        <div className={`absolute right-0 mt-2 w-40 rounded-xl overflow-hidden z-50
                        ${
                          isRetailerMobile
                            ? "bg-white/60 backdrop-blur-3xl border border-white/40 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
                            : "bg-white shadow-lg border"
                        }`}>
          {/* Dynamic Menu Items */}
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                setOpen(false);
                item.onClick?.(navigate);
              }}
              className={`w-full text-left px-4 py-2 text-sm transition
                ${
                  isRetailerMobile
                    ? "text-slate-800 hover:bg-white/20"
                    : "hover:bg-slate-100"
                }`}
            >
              {item.label}
            </button>
          ))}

          {/* Logout */}
          <button
            onClick={() => {
              setOpen(false);
              onLogout();
            }}
            className={`w-full text-left px-4 py-2 text-sm
              ${
                isRetailerMobile
                  ? "text-rose-600 hover:bg-white/20"
                  : "text-red-600 hover:bg-red-100"
              }`}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
